import FormTransactionAddonWrapper, {
  FormTransactionAddonWrapperRef,
} from "@domain/transaction-addon/form-transaction-addon-wrapper/form-transaction-addon-wrapper";
import "./edit-transaction-new-addon.scss";
import { TransactionAddonFormSchema } from "@factory/form/form.rule";
import { useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { currencyFormat } from "@shared/utility/formats/currency-format";
import { Button } from "primereact/button";
import { useQyCreateTransactionAddon } from "@factory/query/transaction-addon.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { useNavigate, useParams } from "react-router-dom";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { Dialog } from "primereact/dialog";

/* eslint-disable-next-line */
export interface EditTransactionNewAddonProps {
  onAdd?: () => void;
}

export function EditTransactionNewAddon({
  onAdd,
}: EditTransactionNewAddonProps) {
  const navigate = useNavigate();
  const { showSuccess, showError } = useNotificationContext();
  const { transactionId } = useParams();
  const { mapCreateTransactionAddon } = useFormApiMapper();
  const [addonFormData, setAddonFormData] = useState<
    TransactionAddonFormSchema[]
  >([]);
  const addonTransactionRef = useRef<FormTransactionAddonWrapperRef>(null);
  const handleAddonTrigger = () => {
    if (addonTransactionRef.current) {
      addonTransactionRef.current.triggerSubmit();
    }
  };
  const handleAddonForm = (data: TransactionAddonFormSchema) => {
    setAddonFormData((prev) => [...prev, data]);

    if (addonTransactionRef.current) {
      addonTransactionRef.current.triggerReset();
    }
  };

  const { mutateAsync: addAddon } = useQyCreateTransactionAddon();
  const handleSaveSelection = async () => {
    try {
      await Promise.all(
        addonFormData.map((item) => {
          const updatedForm = mapCreateTransactionAddon({
            item: item.item,
            amount: item.itemData.amount,
            quantity: item.quantity,
            batch: transactionId,
          });
          return addAddon(updatedForm);
        })
      );

      if (onAdd) {
        onAdd();
      }

      showSuccess("Addons added");
      navigate(-1);
    } catch (error) {
      showError("Something went wrong");
    }
  };

  return (
    <div id="EditTransactionNewAddon" className="edit-transaction-new-addon">
      <Dialog
        header="Add Addon"
        visible={true}
        onHide={() => navigate(-1)}
        style={{ width: "60vw" }}
        draggable={false}
        resizable={false}
        modal
      >
        <section className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
          <FormTransactionAddonWrapper
            ref={addonTransactionRef}
            onSubmit={handleAddonForm}
          />

          <div>
            <small className="block mt-4">Selected Addons</small>
            <DataTable value={addonFormData}>
              <Column
                body={(cell) => <div>{cell.itemData?.name}</div>}
                header="Name"
              ></Column>
              <Column
                body={(cell) => currencyFormat(cell.itemData?.amount || 0)}
                header="Price"
              ></Column>
              <Column field="quantity" header="Quantity"></Column>
              <Column
                body={(cell) => currencyFormat(cell.amount || 0)}
                field="amount"
                header="Amount"
              ></Column>
            </DataTable>
          </div>
        </section>
        <div className="flex pt-4 justify-between">
          <section className="flex gap-2">
            <Button
              label="Add Addon"
              icon="pi pi-plus"
              iconPos="right"
              outlined
              onClick={handleAddonTrigger}
            />
          </section>
          <Button
            label="Save Selection"
            icon="pi pi-save"
            iconPos="right"
            onClick={handleSaveSelection}
          />
        </div>
      </Dialog>
    </div>
  );
}

export default EditTransactionNewAddon;
